module.exports = "<div>\r\n\r\n    <!--<div id=\"QrScanner\" class=\"row\" style=\"display:none;\">\r\n        <div class=\"col-lg-12\">\r\n            <div class=\"panel adminPanel\">\r\n                <qr-scanner [debug]=\"false\"\r\n                            [canvasWidth]=\"100\"\r\n                            [canvasHeight]=\"100\"\r\n                            [stopAfterScan]=\"true\"\r\n                            [updateTime]=\"500\">\r\n                </qr-scanner>\r\n            </div>\r\n        </div>\r\n    </div>-->\r\n    <router-outlet></router-outlet>\r\n</div>\r\n\r\n"


//////////////////
// WEBPACK FOOTER
// ./app/app.template.html
// module id = 589
// module chunks = 3